import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Col, Button, Row } from "reactstrap";
import { validatePhone } from "../../../../utils/validations";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
import "../AddTool.css";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import "./LocationAndContact.css";
import { classnames } from "../../../../utils/place-autocomplete-helpers";
import validator from "validator";

export default class LocationAndContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: this.props.toolDetails.address || "",
      contactName: this.props.toolDetails.contactName,
      contactEmailID: {
        value: this.props.toolDetails.contactEmailID,
        error: false,
      },
      contactPhone: {
        value: this.props.toolDetails.contactPhone,
        error: false,
      },
      website: {
        value: this.props.toolDetails.website,
        error: false,
      },
     
      error: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkUpdateField = (val) => {
    console.log("val---", val);
    if (this.props.tool_status == "Edit") {
      this.props.updateToolFields(val);
    }
  };

  handleChange = (address) => {
    this.setState({ address: address, latitude: null, longitude: null });
    this.checkUpdateField("address");
  };

  handleSelect = (address, latitude, longitude) => {
    this.setState({ address: address });
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        // console.log('LatLong' ,latLng);
        this.setState({address: address, latitude: latLng.lat, longitude: latLng.lng});
      })
      .catch(error => console.error('Error', error));
  };

  handleChangeToolContactName = (event) => {
    this.setState({ contactName: event.target.value });
    this.checkUpdateField("contactName");
  };

  handleChangeToolContactEmail = (event) => {
    this.setState({ contactEmailID: { value: event.target.value } });
    this.checkUpdateField("contactEmailID");
  };
  handleChangeToolContactPhone = (event) => {
    this.setState({ contactPhone: { value: event.target.value } });
    this.checkUpdateField("contactPhone");
  };

  handleChangeToolWebsite = ({ target }) => {
    this.setState({ website: { value: target.value } });
    this.checkUpdateField("website");
  };

  validateToolLocationAndContact = () => {
    let localState = { ...this.state };
    if (
      localState.contactEmailID.value &&
      localState.contactEmailID.value !== "" &&
      !validator.isEmail(localState.contactEmailID.value)
    ) {
      this.setState({
        contactEmailID: {
          value: localState.contactEmailID.value,
          error: true,
          errorMessage:
            "Please enter a valid email address, e.g. example@example.com.",
        },
      });
    } else if (
      localState.contactPhone.value &&
      localState.contactPhone.value !== "" &&
      !validatePhone(localState.contactPhone.value)
    ) {
      this.setState({
        contactPhone: {
          value: localState.contactPhone.value,
          error: true,
          errorMessage: "Please enter a valid mobile number, e.g. 222-333-4444.",
        },
      });
    } else if (
      localState.website.value &&
      localState.website.value !== "" &&
      !validator.isURL(localState.website.value, [
        ,
        { protocols: ["http", "https", "ftp"] },
      ])
    ) {
      this.setState({
        website: {
          value: localState.website.value,
          error: true,
          errorMessage:
            "Please enter a valid web address, e.g. www.example.com.",
        },
      });
    } else {
      if (
        localState.contactEmailID.value &&
        localState.contactEmailID.value !== ""
      ) {
        localState.contactEmailID = localState.contactEmailID.value;
      } else {
        localState.contactEmailID = "";
      }
      if (
        localState.contactPhone.value &&
        localState.contactPhone.value !== ""
      ) {
        localState.contactPhone = localState.contactPhone.value;
      } else {
        localState.contactPhone = "";
      }
      if (localState.website.value && localState.website.value !== "") {
        localState.website = localState.website.value;
      } else {
        localState.website = "";
      }
      delete localState.error;
      delete localState.errorMessage;
      this.props.onCompleted({ ...localState });
    }
  };

  goToPreviousStep = () => {
    this.props.goBackToPreviousStep();
  };

  render() {
    let {
      address,
      contactName,
      contactEmailID,
      contactPhone,
      website,
      error,
      errorMessage,
    } = { ...this.state };
    let alert = null;
    if (error) {
      alert = <ErrorMessage message={errorMessage} />;
    }
    return (
      <Form>
        {alert}
        <FormGroup row>
          <Col sm={3} className="text-right">
            <div className="text-right addToolLabel">Contact Address</div>
            <div className="focus-instruction text-optional">(optional)</div>
          </Col>
          <Col sm={9}>
            <PlacesAutocomplete
          onChange={this.handleChange}
          value={address}
          onSelect={this.handleSelect}
          onError={this.handleError}
          shouldFetchSuggestions={address && address.length > 2}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => {
            return (
              <div>
                <div className="search-input-container">
                  <input
                    {...getInputProps({
                      placeholder: 'Start typing the address or geographic area',
                      className: 'search-input',
                    })}
                  />
                </div>
                {suggestions.length > 0 && (
                  <div className="autocomplete-container">
                    {suggestions.map(suggestion => {
                      const className = classnames('suggestion-item', {
                        'suggestion-item--active': suggestion.active,
                      });

                      return (
                     
                        <div
                          {...getSuggestionItemProps(suggestion, { className })}
                        >
                          <strong>
                            {suggestion.formattedSuggestion.mainText}
                          </strong>{' '}
                          <small>
                            {suggestion.formattedSuggestion.secondaryText}
                          </small>
                        </div>
                      );
                   
                    })}
                  </div>
                )}
              </div>
            );
          }}
        </PlacesAutocomplete>
          </Col>
        </FormGroup>
        <FormGroup row className="mt25">
          <Col sm={3} className="text-right">
            <div className="text-right addToolLabel">Contact Name</div>
            <div className="focus-instruction text-optional">(optional)</div>
          </Col>
          <Col sm={9}>
            <Input
              type="text"
              name="contactName"
              id="contactName"
              className="input-custom"
              onChange={this.handleChangeToolContactName}
              value={contactName}
              placeholder="Provide individual/organization name to be contacted"
            />
          </Col>
        </FormGroup>
        <FormGroup row className="mt25">
          <Col sm={3} className="text-right">
            <div className="text-right addToolLabel">Contact Email</div>
            <div className="focus-instruction text-optional">(optional)</div>
          </Col>
          <Col sm={9}>
            <Input
              type="text"
              name="contactEmail"
              id="contactEmail"
              className="input-custom"
              onChange={this.handleChangeToolContactEmail}
              value={contactEmailID.value}
              placeholder="e.g. example@example.com"
              invalid={contactEmailID.error}
            />
            {contactEmailID.error ? (
              <div className="input-error-msg-field">
                {contactEmailID.errorMessage}
              </div>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup row className="mt25">
          <Col sm={3} className="text-right">
            <div className="text-right addToolLabel">Contact Phone</div>
            <div className="focus-instruction text-optional">(optional)</div>
          </Col>
          <Col sm={9}>
            <Input
              type="tel"
              name="contactPhone"
              id="contactPhone"
              className="input-custom"
              onChange={this.handleChangeToolContactPhone}
              value={contactPhone.value}
              placeholder="Provide country code (if outside US) followed by number"
              invalid={contactPhone.error}
            />
            {contactPhone.error ? (
              <div className="input-error-msg-field">
                {contactPhone.errorMessage}
              </div>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={3} className="text-right">
            <div className="text-right addToolLabel">Website</div>
            <div className="focus-instruction ">(optional)</div>
          </Col>
          <Col sm={9} className="align-self-center">
            <Input
              type="text"
              name="website"
              id="website"
              className="input-custom"
              value={website.value}
              onChange={this.handleChangeToolWebsite}
              placeholder="e.g. https://www.example.com"
              invalid={website.error}
            />
            {website.error ? (
              <div className="input-error-msg-field">
                {website.errorMessage}
              </div>
            ) : null}
          </Col>
        </FormGroup>
        <FormGroup className="mt40">
          <Row>
            <Col sm={{ size: 3 }}>
              <Button
                className="float-left goBackBtn w100"
                onClick={this.goToPreviousStep}
              >
                <span className="goBackBtnTxt">
                  <span className="mr10 flaticon-back"></span> Go Back
                </span>
              </Button>
            </Col>
            <Col sm={{ size: 3, offset: 6 }}>
              <Button
                className="float-right continueBtn ml10 w100"
                onClick={this.validateToolLocationAndContact}
              >
                <span className="continueBtnTxt">
                  Continue <span className="ml10 flaticon-next"></span>
                </span>
              </Button>
            </Col>
          </Row>
        </FormGroup>
      </Form>
    );
  }
}
